/**
 * @file コンポーネント：段落 ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
// デフォルトの段落
export const Paragraph = (props) => {
    // Presenterに渡す
    return <Presenter {...props} />;
};
